/**
 * SPA hotel details controller
 */
define('controllers/hotel/adestinndetails',['require','layout','utils','models','fadegallery','components/map','components/modal','moment','cookieutil','services/bookingService','services/userService','rv!templates/booking/hoteladestinndetails','rv!templates/partials/carousel','rv!templates/partials/availableRoomList','rv!templates/partials/ManualBookingForm','rv!templates/partials/messenger','rv!templates/partials/nightlyRates','rv!templates/partials/hotelRating','rv!templates/partials/star','rv!templates/partials/halfStar'],function (require) {
    'use strict';
    var layout = require('layout');
    var utils = require('utils');
    var models = require('models');
    var initSlideShow = require('fadegallery');
    var Map = require('components/map');
    var Modal = require('components/modal');
    var moment = require('moment');
    var cookieutil = require('cookieutil');
    var bookingService = require('services/bookingService');
    var userService = require('services/userService');

    return {
        /**
         * Note we 
         * @param {} hotelId 
         * @param {} data 
         * @param {} state 
         * @returns {} 
         */
        load: function (hotelId, querystring, state) {
            var planningData = bookingService.deserializePlanning(querystring);

            if (planningData != null &&
                planningData.Provider != null &&
                planningData.DestinationInfo.VRegion != null &&
                planningData.DestinationInfo.VRegion.RegionID != null &&
                planningData.DestinationInfo.VRegion.RegionName != null) {
                var provider = planningData.Provider;
                // region name might be null if the user didn't come from the search page
                var regionName = planningData.DestinationInfo.VRegion.RegionName;
                var regionId = planningData.DestinationInfo.VRegion.RegionID;


                if (hotelId != null) {
                    hotelId = hotelId.replace('?hid=', ''); //so old links work that get redirected here from old aspx page...   
                }
                if (!utils.isInt(hotelId)) {
                    window.location.hash = '/hotel-new-search';
                    return;
                }

                this.state = state;
                this.state.cached = false;


                var searchItems = utils.getLastSearch();
                var coMemberBook = (utils.getCoMemberBookId() !== 'member-book').toString();

                planningData = this._searchMetaToPlanningData(searchItems);
                planningData.DestinationInfo.VRegion.RegionName = regionName;
                planningData.DestinationInfo.VRegion.RegionID = regionId;
                planningData.TravelerInfo.CoMemberBook = coMemberBook;
                planningData.TravelerInfo.CoMemberAltName = utils.getAltMemberName();




                var cachedHotelId = utils.tryGetValue(this.state, 'data.HotelId');

                var hotelCall = $.get('/api/hotels/details/?provider={0}&hotelId={1}'.format(provider, hotelId));

                var hotelData = null;
                if (cachedHotelId === hotelId) {
                    hotelData = this.state.data;
                    this.state.cached = true;
                    this.prevPlanningData = this.state.data.planningData;
                } else {
                    this.state.cancellationPolicies = null;
                }

                if (userService.isLoggedIn()) {
                    var userInfoCall = $.get('/api/users/userbookinginformation');
                    userInfoCall.then(function (userInfo) {
                        if (hotelData === null) {
                            hotelCall.then(function (response) {
                                this.state.data = response;
                                this.init(planningData, response, userInfo);
                            }.bind(this));
                        } else {
                            this.init(planningData, hotelData, userInfo);
                        }
                    }.bind(this));
                } else {
                    if (hotelData === null) {
                        hotelCall.then(function (response) {
                            this.state.data = response;
                            this.init(planningData, response, null);
                        }.bind(this));
                    } else {
                        this.init(planningData, hotelData, null);
                    }
                }

            } else {
                window.location.hash = '/hotel-new-search';
            }
        },
        getDefaultAvailability: function () {
            return {
                rooms: [],
                AchCount: 0
            };
        },

        init: function (planningData, hoteldata, userInfo) {
            // Track changes in occupancy button
            this.state.changes = false;
            this.initPlanningData = planningData;

            planningData = this.mutatePlanningData(planningData, hoteldata);
            hoteldata = this.mutateHotelData(planningData, hoteldata);

            hoteldata.perfectSaverAmount = this.getPerfectSaverAmount(hoteldata);

            this.initRactive(hoteldata, userInfo);

            this.setBreadCrumbs();

            initSlideShow();
            //this.handleRegisterInterest(hoteldata);
            this.handleVerifyEmail();
            layout.initGlobalHandlers();
            document.title = hoteldata.Name;
            this.dialog = new Modal($('#google-map-dialog'));

            this._initDateBoxEvents();
            this._initGuestEvents();

            var radioButtons = document.querySelectorAll('.travel-member-changeable');
            var savedRadioId = utils.getCoMemberBookId();
            var altMemberName = utils.getAltMemberName();
            var altMember = document.getElementById('alt-member-name-book');

            // If there is a saved radio button id in local storage, set the corresponding radio button as checked
            if (savedRadioId) {
                var savedRadio = document.getElementById(savedRadioId);
                if (savedRadio) {
                    savedRadio.checked = true;
                }

                if (altMember !== null && altMemberName !== null && altMemberName !== '') {
                    altMember.value = altMemberName;
                }
            }

            // Add an event listener to save the selected radio button's id to local storage when it changes
            radioButtons.forEach(radio => {
                radio.addEventListener('change', function () {
                    if (this.checked) {
                        utils.setCoMemberBookId(this.id);
                    }
                });
            });

            if (altMember != null) {
                altMember.addEventListener('change', function () {
                    utils.setAltMemberName(document.getElementById('alt-member-name-book').value);
                });
            }

            $('#fromDate').val(planningData.Timeline.FromDate.format('YYYY-MM-DD'));
            $('#toDate').val(planningData.Timeline.ToDate.format('YYYY-MM-DD'));

            $('.hotel-availability-form .search-changeable').on('change', function () {
                this._updateSearchMeta();
            }.bind(this));

            $('#childAgeInput').on('change', 'input', function () {
                this._updateSearchMeta();
            }.bind(this));

            $('.travel-member-changeable').on('change', function () {
                this._updateSearchMeta();
            }.bind(this));
            // ── AI Concierge autofill ─────────────────────────────────
            // Reads 'aiTripData' from localStorage (written by home.html).
            // Apply BEFORE _setSearchMeta so Ractive gets the right data.
            // Use plain YYYY-MM-DD strings — NOT moment objects — to avoid
            // Ractive serializing them as ISO Date strings in the inputs.
            var _aiTripData = null;
            try {
                var aiTripRaw = localStorage.getItem('aiTripData');
                if (aiTripRaw) {
                    var aiTrip = JSON.parse(aiTripRaw);
                    localStorage.removeItem('aiTripData'); // one-time use
                    if (aiTrip && aiTrip.startDate && aiTrip.endDate) {
                        _aiTripData = aiTrip; // save for DOM patch below
                        // Use plain strings so Ractive doesn't mangle them
                        planningData.Timeline.FromDate = aiTrip.startDate;
                        planningData.Timeline.ToDate = aiTrip.endDate;
                        planningData.TravelerInfo.AdultCount = aiTrip.travelers || 2;
                        var aiAges = Array.isArray(aiTrip.childrenAges) ? aiTrip.childrenAges : [];
                        planningData.TravelerInfo.ChildAges = aiAges;
                        planningData.TravelerInfo.ChildCount = aiAges.length;
                        console.log('[AI] Autofill applied:', aiTrip);
                    }
                }
            } catch (aiErr) {
                console.warn('[AI] Autofill error:', aiErr);
            }
            // ─────────────────────────────────────────────────────────

            this._setSearchMeta(planningData);

            // ── AI date DOM patch ──────────────────────────────────────
            // Force YYYY-MM-DD strings directly onto the date inputs.
            // This runs last so nothing can overwrite it.
            if (_aiTripData) {
                setTimeout(function () {
                    $('#fromDate').val(_aiTripData.startDate);
                    $('#toDate').val(_aiTripData.endDate);
                    console.log('[AI] Date inputs patched:', _aiTripData.startDate, '->', _aiTripData.endDate);
                }, 0);
            }
            // ─────────────────────────────────────────────────────────

            if (userService.isLoggedIn() && userInfo && userInfo.EmailVerified) {
                // update cancellation policies when changed
                $(document).on('change', 'input.cancellation-policy', function (e) {
                    this._updateCancellationPolicies(e);
                    this.validateManualBooking();
                }.bind(this));

                this.fetchRooms(null, planningData);
            }
        },

        _initGuestEvents: function () {
            $('#hotelGuestsButton').on('click', function (e) {
                e.stopPropagation();
                $('.hotel-guest-inputs-container').toggle();
            });

            // Close occupant popup
            $('body').on('click', function (e) {
                var context = $(this);
                // when event is not hotelGuestsButton
                if (context.attr('id') !== 'hotelGuestsButton') {
                    // and event is not a child of the .hotel-guest-inputs-container
                    if (!$(e.target).is('.hotel-guest-inputs-container *, .hotel-guest-inputs-container')) {
                        $('.hotel-guest-inputs-container').hide();
                    }
                }
            });
        },

        _updateSearchMeta: function () {
            var planning = this.ractive.get('data.planningData');
            console.log('planning', planning);
            var buffAges = $('#childAgeInput input').toArray().map(function (input) {
                return $(input).val();
            });

            planning.TravelerInfo.ChildAges = new Array(planning.TravelerInfo.ChildCount);
            for (var i = 0; i < planning.TravelerInfo.ChildCount; i++) {
                planning.TravelerInfo.ChildAges[i] = buffAges[i] ? buffAges[i] : 0;
            }
            this._setSearchMeta(planning);
            this.clearRooms();
            this.clearPreviousResults();
        },

        _updateCancellationPolicies: function (event) {
            var tar = event.currentTarget.id;
            if (tar === undefined ||
                tar.length <= 0) {
                return;
            }

            var policies = this.ractive.get('data.planningData.DestinationInfo.Rate.CancellationPolicies');
            var index = tar.charAt(tar.length - 1) - 1;
            if (tar.includes('policyAmount')) {
                policies[index].Amount = $(event.currentTarget).val();
            } else if (tar.includes('policyDate')) {
                policies[index].From = $(event.currentTarget).val();
            } else if (tar.includes('loyaltyPolicyAmount')) {
                console.log('loyaltyAmount updated');
                policies[index].LoyaltyAmount = $(event.currentTarget).val();
            }
            this.ractive.set('data.planningData.DestinationInfo.Rate.CancellationPolicies', policies);
        },

        _updateChildrenAges: function () {
            $('#childAgeInput').empty();
            $('#childAgeInput').show();
            var inputNumber = $('input#childrenNumber').val();

            var ages = this.ractive.get('data.planningData.TravelerInfo.ChildAges');

            if (inputNumber > 0 && inputNumber <= 10) {
                var buff = 0;
                for (var i = 0; i < inputNumber; i++) {
                    if (ages[i] != null) {
                        buff = ages[i];
                    } else {
                        buff = 0;
                    }
                    $('#childAgeInput').append('<label for=childAge' + (i + 1) + '>Child #' + (i + 1) + ' Age: </label><input type=number value=' + buff + ' min=0 max=17 id=childAge' + (i + 1) + ' />');
                }
            } else {
                $('#childAgeInput').hide();
            }
        },

        _setSearchMeta: function (planning) {
            this.ractive.set('data.planningData', planning);
            this._updateChildrenAges();

            if (planning.TravelerInfo.AdultCount <= 1) {
                this.ractive.set('adultTag', 'adult');
            } else if (planning.TravelerInfo.AdultCount > 1) {
                this.ractive.set('adultTag', 'adults');
            }

            if (planning.TravelerInfo.ChildCount <= 1) {
                this.ractive.set('childTag', 'child');
            } else if (planning.TravelerInfo.ChildCount > 1) {
                this.ractive.set('childTag', 'children');
            }

            var meta = this._planningDataToSearchMeta(planning);
            // tack on the region and mileage that were previously entered
            var prev = utils.getLastSearch();
            meta.region = prev.region;
            meta.mileage = prev.mileage;

            utils.setLastSearch(meta);
        },

        _planningDataToSearchMeta: function (planningData) {
            return {
                fromDate: planningData.Timeline.FromDate,
                toDate: planningData.Timeline.ToDate,
                adults: planningData.TravelerInfo.AdultCount,
                children: planningData.TravelerInfo.ChildCount,
                childrenAges: planningData.TravelerInfo.ChildAges,
                coMemberBook: planningData.TravelerInfo.CoMemberBook.toString(),
                coMemberAltName: planningData.TravelerInfo.CoMemberAltName,
                mileage: 25,
                region: ''
            };
        },
        _searchMetaToPlanningData: function (meta) {
            var data = {
                TravelerInfo: {
                    AdultCount: meta.adults,
                    ChildCount: meta.children,
                    ChildAges: meta.childrenAges,
                    CoMemberBook: meta.coMemberBook.toString(),
                    CoMemberAltName: meta.coMemberAltName,
                },
                Timeline: {
                    FromDate: meta.fromDate,
                    ToDate: meta.toDate,
                },
                DestinationInfo: {
                    DestinationSourceID: 0,
                    LookupSource: '',
                    HotelCode: 0,
                    ChainCode: 0,
                    RoomCount: 1,
                    RateKey: '',
                    RoomName: '',
                    RoomDescription: '',
                    VRegion: {
                        RegionName: '',
                        RegionID: 0,
                    },
                    Rate: {
                        RateCode: 0,
                    }
                },
                Provider: 0,
            };
            return data;
        },
        mutateHotelData: function (planningData, hoteldata) {
            hoteldata.planningData = planningData;
            hoteldata.Region = planningData.DestinationInfo.VRegion.RegionName;
            hoteldata.DisplayAddress = this.getDisplayAddress(hoteldata);
            return hoteldata;
        },
        // Any info that needs to be updated for planningData should happen here
        mutatePlanningData: function (planningData, hotelData) {
            planningData.DestinationInfo.DestinationSourceID = parseInt(hotelData.HotelId);
            planningData.TravelerInfo.ChildCount = planningData.TravelerInfo.ChildAges.length;
            planningData.TravelerInfo.CoMemberBook = planningData.TravelerInfo.CoMemberBook.toString();
            planningData.DestinationInfo.LookupSource = hotelData.LookupSource;
            planningData.DestinationInfo.HotelCode = hotelData.HotelCode;
            planningData.DestinationInfo.HotelCategory = hotelData.CategoryName;
            planningData.DestinationInfo.ChainCode = hotelData.ChainCode;
            planningData.DestinationInfo.RoomCount = 1;
            planningData.Provider = hotelData.ProviderCode;
            planningData.DestinationInfo.Rate.CancellationPolicies = [];
            return planningData;
        },

        _initDateBoxEvents: function () {
            var from = $('#fromDate');
            var to = $('#toDate');
            from.on('change', function (e) {
                if (from.val() >= to.val()) {
                    var date = moment(from.val());
                    date.add(1, 'days');
                    var c = date.format('YYYY-MM-DD');
                    to.val(c);
                    var data = this.ractive.get('data');
                    data.planningData.Timeline.ToDate = c;
                }
            }.bind(this));

            to.on('change', function (e) {
                if (to.val() <= from.val()) {
                    var date = moment(to.val());
                    date.subtract(1, 'days');
                    var c = date.format('YYYY-MM-DD');
                    from.val(c);
                    var data = this.ractive.get('data');
                    data.planningData.Timeline.FromDate = c;
                }
            }.bind(this));
        },

        getDisplayAddress: function (h) {
            var value = utils.isNullOrWhiteSpace(h.DisplayAddress)
                ? '{0} {1} {2} {3}, {4} {5}'.format(h.Address1 || '', h.Address2 || '', h.City || '', h.StateProvince || '', h.Country || '', h.PostalCode || '') // jshint ignore:line
                : h.DisplayAddress;
            return value.replace(/[!@$%^&*()?":{}|<>]/g, '');
        },

        getPerfectSaverAmount: function (hotel) {
            return hotel.MinPriceRange != null ?
                this.getApproxSavings(hotel.MinimumRate) :
                this.getApproxSavings(hotel.MaximumRate);
        },

        getApproxSavings: function (price) {
            if (price == null) {
                return null;
            }
            var amountNeeded = ((6 * price) / 1.5);
            var payPeriodSavingsNeeded = amountNeeded / 52;
            return payPeriodSavingsNeeded;
        },
        initRactive: function (hoteldata, userInfo) {
            hoteldata.user = userInfo;
            if (hoteldata.Lat != null && hoteldata.Long != null) {
                hoteldata.Region = hoteldata.Lat + ',' + hoteldata.Long;
            }

            this.ractive = layout.initRactive(
                {
                    data: hoteldata,
                    Settings: window.ServerData.Settings,
                    showCoTraveler: hoteldata.user && hoteldata.user.CoTraveler != null,
                    contentUrl: window.ServerData.StaticContentUrl,
                    isDba: window.ServerData.user && window.ServerData.user.isDba,
                    isMAW: window.ServerData.user && (window.ServerData.user.id.toString().toLowerCase() === '6D3FC413-D74E-494D-8CCE-D5E534ABEC36'.toLowerCase() || window.ServerData.user.id.toString().toLowerCase() === 'B5634949-0BB7-4719-BCE8-7559D4EC9724'.toLowerCase()) ? true : false,
                    showGdsData: false,
                    provider: models.provider,
                    metersToFeet: function (value) {
                        return (value * 3.28084).toFixed(1);
                    },
                    metersToMiles: function (value) {
                        return (value / 1609.344).toFixed(1);
                    },
                    formatPhone: window.Utilities.formatPhoneNumber,
                    selectedDetailTypeId: hoteldata.Description.length > 0 ? hoteldata.Description[0].DetailTypeID : 0,
                    STATUSES: { //todo: centralize this (see Hotels.AdestinnStatus) and probably put into a constants file 
                        Active: 'Active',
                        Pending: 'Pending Activation',
                        LikelyToParticipate: 'Likely To Participate',
                        NoLongerActive: 'No Longer Active'
                    }
                },
                require('rv!templates/booking/hoteladestinndetails'),
                {
                    partials: {
                        carousel: require('rv!templates/partials/carousel'),
                        availableRoomList: require('rv!templates/partials/availableRoomList'),
                        ManualBookingForm: require('rv!templates/partials/ManualBookingForm'),
                        messenger: require('rv!templates/partials/messenger'),
                        nightlyRates: require('rv!templates/partials/nightlyRates'),
                        hotelRating: require('rv!templates/partials/hotelRating'),
                        star: require('rv!templates/partials/star'),
                        halfStar: require('rv!templates/partials/halfStar'),
                    }
                });


            this.ractive.on({
                onMapClick: this.onMapClick.bind(this),
                onClickDetail: this.onClickDetail.bind(this),
                onCloseMap: this.onCloseMap.bind(this),
                fetchRooms: this.fetchRooms.bind(this),
                loginToViewAvailability: this.loginToViewAvailability.bind(this),
                onManualBook: this.onManualBook.bind(this),
                getPerfectSaverMessage: this.getPerfectSaverMessage.bind(this),
                clearRooms: this.clearRooms.bind(this),
                updateManualBooking: this.validateManualBooking.bind(this),
                onPhoneChange: this.onPhoneChange.bind(this),
                onGetRateDetails: this.onGetRateDetails.bind(this),
                onAddPolicy: this.onAddPolicy.bind(this),
                onRemovePolicy: this.onRemovePolicy.bind(this),
            });
        },

        onAddPolicy: function () {
            var policies = this.ractive.get('data.planningData.DestinationInfo.Rate.CancellationPolicies');
            if (policies.length <= 5) {
                policies.push({ Amount: '', LoyaltyAmount: '', From: '', FromUTC: '', OffsetUTC: '' });
                this.ractive.set('data.planningData.DestinationInfo.Rate.CancellationPolicies', policies);
                this.updatePolicyDisplay();
            }
            this.validateManualBooking();
        },

        updatePolicyDisplay: function () {
            var policies = this.ractive.get('data.planningData.DestinationInfo.Rate.CancellationPolicies');
            $('#hotelbedsCancellationInputs').empty();
            for (var i = 0; i < policies.length; i++) {
                $('#hotelbedsCancellationInputs').append('<div class=span4><label for=policyDate' + (i + 1) + '>Policy Date ' + (i + 1) + ' *</label><span class=sideNote>(Ex: 2022-01-20T23:59:00-05:00)</span><input type=text value="' + policies[i].From + '" class=cancellation-policy id=policyDate' + (i + 1) + ' /></div>' +
                    '<div class=span4><label for=policyAmount' + (i + 1) + '>Selling Policy Amount ' + (i + 1) + ' *</label><input type=text value="' + policies[i].Amount + '" class=cancellation-policy id=policyAmount' + (i + 1) + ' /></div>' +
                    '<div class=span4><label for=loyaltyPolicyAmount' + (i + 1) + '>Loyalty Policy Amount ' + (i + 1) + ' *</label><input type=text value="' + policies[i].LoyaltyAmount + '" class=cancellation-policy id=loyaltyPolicyAmount' + (i + 1) + ' /></div>');
            }
        },

        onRemovePolicy: function () {
            var policies = this.ractive.get('data.planningData.DestinationInfo.Rate.CancellationPolicies');
            if (policies.length) {
                policies.pop();
                this.ractive.set('data.planningData.DestinationInfo.Rate.CancellationPolicies', policies);
                this.updatePolicyDisplay();
            }
            this.validateManualBooking();
        },

        setBreadCrumbs: function () {
            layout.setBreadCrumbs([
                {
                    name: 'Search',
                    url: '/#/hotel-new-search'
                },
                {
                    name: 'Hotel Details'
                }
            ]);
        },


        getPerfectSaverMessage: function (psPreviewAmount, achCount, linked) {
            var monthlyAmount = achCount > 0 ? psPreviewAmount / achCount : psPreviewAmount / 12;
            if (linked) {
                if (psPreviewAmount <= 0) {
                    return 'You\'re saving enough to book this room.';
                }
                return achCount > 0 ?
                    '{0} added to your next {1}contribution{2} pays for this booking.'.format(utils.formatMoney(monthlyAmount), achCount > 1 ? achCount + ' ' : '', achCount > 1 ? 's' : '') :
                    'Need to add {0} to pay for this booking.'.format(utils.formatMoney(psPreviewAmount));
            } else {
                return 'Annual Vacation Savings Plan Preview: {0} per month'.format(utils.formatMoney(monthlyAmount));
            }
        },

        /**
         * Just pulled this from old code, but refactor to do it ractive style...
         */
        handleRegisterInterest: function (hoteldata) {
            var vote = hoteldata.vote;
            var hotelid = hoteldata.hotel.HotelID;
            var $phHotelInterest = $('#phHotelInterest');
            var canRegisterInterest = $phHotelInterest.length > 0;
            if (canRegisterInterest) {
                var $interestComment = $('#interestComment');
                var $alreadyVoted = $('#alreadyVoted');
                var $votePanel = $('#votePanel');
                var $afterRegisterInterest = $('#afterRegisterInterest');

                var showRegisterStep = function (step) {
                    $votePanel.hide();
                    $alreadyVoted.hide();
                    $afterRegisterInterest.hide();
                    step === 1 ? $votePanel.show() : step === 2 ? $alreadyVoted.show() : $afterRegisterInterest.show();
                    if (step === 2) {
                        $interestComment.focus();
                    }
                };

                var onRegisterInterest = function () {
                    var $this = $(this);
                    $this.prop('disabled', true);
                    $this.attr('id') === 'btnRegisterInterest' ? showRegisterStep(2) : showRegisterStep(3);
                    $.post('/api/hotels/registerinterest', {
                        HotelId: hotelid,
                        UserId: window.ServerData.user != null ? window.ServerData.user.id : null,
                        AnonymousId: cookieutil.get('AnonymousId'),
                        Comment: $interestComment.val(),
                        Interested: true
                    }).then(null, function (xhr) {
                        alert('an error occurred while registering interest. Please reload and try again.');
                    }).then(function () {
                        $this.prop('disabled', false);
                    });
                };

                var hasVoted = vote != null;
                if (hasVoted) {
                    $interestComment.val(vote.Comment);
                    showRegisterStep(3);
                } else {
                    $votePanel.show();
                    $alreadyVoted.hide();
                }
                $('#leaveComment, #btnRegisterInterest').on('click', onRegisterInterest);
                $('#editComment').on('click', function (e) {
                    e.preventDefault();
                    showRegisterStep(2);
                });
                $phHotelInterest.show();
            }
        },

        /**
         * Probably pull this into a component with its partial template if we want to verify email elsewhere...
         */
        handleVerifyEmail: function () {
            var btnCheckEmail = $('.btnCheckEmail'),
                loadingEmailCheck = $('.loadingEmailCheck'),
                emailCheckMsg = $('.emailCheckMsg');

            btnCheckEmail.off('click').on('click', function () {
                btnCheckEmail.hide();
                loadingEmailCheck.show();

                $.ajax({
                    type: 'POST',
                    url: '/public/EmailCheckSimpleAJAX.aspx',
                    data: { url: window.location.toString() },
                    success: function (response) {
                        window.Utilities.handleAJAXResponse(response,
                            function (obj) {
                                window.Utilities.setInfo('We sent you an email.', emailCheckMsg);
                                window.gaTrack('account', 'verify_email', window.ServerData.user.Email, 1);
                            },
                            function (error) {
                                window.Utilities.setError(error, emailCheckMsg);
                            });
                    },
                    error: function () {
                        window.Utilities.setError('Something went wrong. Please re-load the page and try again or contact Adestinn Support.', emailCheckMsg);
                    },
                    complete: function () {
                        btnCheckEmail.show();
                        loadingEmailCheck.hide();
                    }
                });
            });
        },

        onMapClick: function (e) {
            e.original.preventDefault();
            this.dialog.open();
            var hotel = this.ractive.get('data');

            if (this.map == null) {
                this.map = new Map($('#google-map'), [], hotel.planningData.FromDate, hotel.planningData.ToDate);
            }
            this.map.onLoad(function () {
                this.map.plotByLatLng(hotel.Name, hotel.Lat, hotel.Long);
            }.bind(this));
            window.gaTrack('hotel_details', 'map', hotel.Name + ': ' + hotel.HotelId, 1);
        },

        onCloseMap: function (e) {
            this.dialog.close();
        },

        onClickDetail: function (e) {
            e.original.preventDefault();
            this.ractive.set('selectedDetailTypeId', e.context.DetailTypeID);
        },

        loginToViewAvailability: function (e) {
            var returnUrl = encodeURIComponent(window.location.href);
            window.location.href = '/login.aspx/?ReturnUrl=' + returnUrl;
        },

        fetchRooms: function (e, pData) {
            if (e != null) {
                e.original.preventDefault();
            }

            var previousResults = null;
            if (window.app.controllerManager.state.hotelnewsearch !== undefined &&
                window.app.controllerManager.state.hotelnewsearch.searchResults !== undefined) {
                previousResults = window.app.controllerManager.state.hotelnewsearch.searchResults;
            }

            //compare pData and state planning data
            if (!this.compareStateAndPlanning()) {
                // changes have occurred, update state variables
                this.clearRooms();
            }

            var planningData = pData == null ? this.ractive.get('data.planningData') : utils.copy(pData);

            var copyPlanning = utils.copy(planningData);
            copyPlanning.ManualBooking = null;

            console.log('SENDING: ', copyPlanning);

            // AI Concierge (#91): when the chat just loaded this hotel's rooms
            // for the same dates and travelers, show THOSE rooms instead of
            // running a second provider search. They came from the same
            // /api/hotels/roomsavailability call in this session, so their
            // RateKeys are the ones the server holds, and the page and the chat
            // show the same list. A second search would also hold the session
            // lock for up to a minute, stalling the chat. Checked BEFORE the
            // cached-rooms shortcut below, so rooms cached from an earlier
            // visit (e.g. an empty list) never win over the chat's.
            var aiRooms = this._takeAiPrefetchedAvailability(copyPlanning);
            if (aiRooms && this.validateCheckAvailability(copyPlanning) && this.validatePhoneNumber()) {
                console.log('[AI] using the rooms the concierge already loaded');
                this.transformAvailabilityData(aiRooms, planningData);
                return;
            }

            if (this.state.rooms && this.state.cached) {
                console.log('cached rooms');
                this.ractive.set('availability', this.state.rooms);
                return;
            }

            if (this.validateCheckAvailability(copyPlanning) && this.validatePhoneNumber()) {
                this.ractive.set('loadingResults', true);
                if (previousResults !== null && copyPlanning.Provider === models.provider.Hotelbeds && !this.state.changes) {
                    var rooms = this.findPreviousSearchRooms(copyPlanning.DestinationInfo.DestinationSourceID, copyPlanning.Provider, previousResults);
                    if (rooms !== null) {
                        this.checkRequest = $.postJSON('/api/hotels/updateroomsavailability', {
                            provider: copyPlanning.Provider,
                            planningData: copyPlanning,
                            rooms: rooms
                        }).then(function (availability) {
                            this.transformAvailabilityData(availability, planningData);
                        }.bind(this), function (error) {
                            this.ractive.set('loadingResults', false);
                            var errors = [];
                            errors.push(window.Utilities.getFriendlyErrors(error) ||
                                'ERROR | Status Code: ' + error.status + ' - ' + error.statusText);
                            this.ractive.set('messenger.Errors', errors);
                        }.bind(this));

                        // Early return
                        return;
                    }
                }
                // Fallback
                this.checkRequest = $.postJSON('/api/hotels/roomsavailability', {
                    provider: copyPlanning.Provider,
                    planningData: copyPlanning,
                    showGdsData: this.ractive.get('showGdsData')
                }).then(function (availability) {
                    this.transformAvailabilityData(availability, planningData);
                }.bind(this), function (error) {
                    this.ractive.set('loadingResults', false);
                    var errors = [];
                    errors.push(window.Utilities.getFriendlyErrors(error) ||
                        'ERROR | Status Code: ' + error.status + ' - ' + error.statusText);
                    this.ractive.set('messenger.Errors', errors);
                }.bind(this));
            }
        },

        /**
         * AI Concierge (#91): one-time hand-off of the availability the chat
         * loaded (window._aiPrefetchedAvailability, set by ai-booking-engine.js).
         * Used only if it is for this hotel, provider, dates, adults and child
         * ages, and is under 10 minutes old; otherwise the page searches as usual.
         */
        _takeAiPrefetchedAvailability: function (planning) {
            var pre = window._aiPrefetchedAvailability;
            if (!pre) {
                // After a full page load the in-memory copy is gone.
                try { pre = JSON.parse(window.sessionStorage.getItem('aiPrefetchedAvailability') || 'null'); } catch (_) { pre = null; }
            }
            window._aiPrefetchedAvailability = null; // one-time use
            try { window.sessionStorage.removeItem('aiPrefetchedAvailability'); } catch (_) { }
            if (!pre || !pre.availability || !planning) { return null; }
            try {
                var day = function (d) { return d ? String(d).substring(0, 10) : ''; };
                var ages = function (a) { return (Array.isArray(a) ? a : []).map(function (x) { return parseInt(x, 10) || 0; }).join(','); };
                var ti = planning.TravelerInfo || {};
                var di = planning.DestinationInfo || {};
                var tl = planning.Timeline || {};
                var matches =
                    (Date.now() - pre.at) < 10 * 60 * 1000 &&
                    String(pre.hotelId) === String(di.DestinationSourceID) &&
                    parseInt(pre.provider, 10) === parseInt(planning.Provider, 10) &&
                    pre.fromDate === day(tl.FromDate) &&
                    pre.toDate === day(tl.ToDate) &&
                    parseInt(pre.adults, 10) === parseInt(ti.AdultCount, 10) &&
                    pre.childAges === ages(ti.ChildAges);
                if (!matches) {
                    console.log('[AI] concierge rooms not reused — search differs', pre, planning);
                    return null;
                }
                return JSON.parse(JSON.stringify(pre.availability));
            } catch (e) {
                console.warn('[AI] concierge rooms hand-off failed:', e);
                return null;
            }
        },

        findPreviousSearchRooms: function (hotelId, providerCode, searchResults) {
            console.log(searchResults);
            for (var i = 0; i < searchResults.length; i++) {
                //console.log('Provider: ', providerCode, ' | hotelId: ', hotelId)
                if (searchResults[i].ProviderCode === providerCode && searchResults[i].Code === hotelId) {
                    console.log('Provider: ', providerCode, ' | hotelId: ', hotelId, ' | rooms: ', searchResults[i].Rooms);
                    return searchResults[i].Rooms;
                }
            }
            return null;
        },

        transformAvailabilityData: function (availability, planningData) {
            if (availability !== undefined && availability.Rooms !== undefined) {
                availability.Rooms.forEach(function (r) {
                    var roomData = this.getRoomPlanningData(utils.copy(planningData), r); //need a separate planning data obj for each room too. Probably more efficient way to do this, but fixing a prod bug...instead probably just build this when getting rate details...
                    r.planningData = roomData;
                    r.PerfectSaverMessage = this.getPerfectSaverMessage(r.PsPreviewAmount, availability.AchCount, availability.Linked);
                    r.BookingUrl = this.getBookUrl(roomData, false);
                }.bind(this));
                this.ractive.set('availability', availability);
                this.state.rooms = availability;
            }
            this.ractive.set('loadingResults', false);
        },

        /**
         * set room-specific props on planning data, so we can check rate details or choose it.
         */
        getRoomPlanningData: function (planningData, room) {
            planningData.DestinationInfo.RoomTypeCode = room.RoomType;
            planningData.DestinationInfo.RoomCorporateDisc = room.CorporateDiscountCode;
            planningData.DestinationInfo.Rate.RatePlanCode = room.RateCode;
            planningData.DestinationInfo.RoomName = room.Name;
            planningData.DestinationInfo.RoomDescription = room.Desc;
            planningData.DestinationInfo.RateKey = room.RateKey;
            planningData.DestinationInfo.RoomCode = room.RoomCode;
            return planningData;
        },

        /**
         * build up a hash to the booking page, with the info in the manual book form
         */
        onManualBook: function (e) {
            e.original.preventDefault();
            var planningData = this.ractive.get('data.planningData');
            //TODO: navigate to booking page
            planningData.ManualBooking.RoomDescription = '{0}<br/>{1}'.format(planningData.DestinationInfo.RoomName, planningData.ManualBooking.RoomDescription);
            if (this.validateManualBooking(planningData)) {
                this._parseCancellationPolicies();
                window.location.hash = this.getBookUrl(planningData, true)
                    .replace(/^\/#/, '');
            }
        },

        _parseCancellationPolicies: function () {
            var policies = this.ractive.get('data.planningData.DestinationInfo.Rate.CancellationPolicies');

            // Create regular policies
            for (var i = 0; i < policies.length; i++) {
                policies[i].FromUTC = policies[i].From.substring(0, policies[i].From.length - 6);
                // chop off the last 6 characters for offset
                policies[i].OffsetUTC = policies[i].From.substring(policies[i].From.length - 6);
            }

            var loyaltyPolicies = policies.map(function (a) { return Object.assign({}, a); });

            // swap amounts for loyalty cancellation
            for (var j = 0; j < loyaltyPolicies.length; j++) {
                loyaltyPolicies[j].Amount = loyaltyPolicies[j].LoyaltyAmount;
            }

            this.ractive.set('data.planningData.DestinationInfo.Rate.CancellationPolicies', policies);
            this.ractive.set('data.planningData.DestinationInfo.Rate.CheckRateCancellationPolicies', loyaltyPolicies);
        },

        validateManualBooking: function (e) {
            this.removeCharacters();
            var planningData = this.ractive.get('data.planningData');

            // Testing cancel form
            /*
            planningData.DestinationInfo.Rate.LoyaltyRoomRateTotal = 120.73;
            planningData.DestinationInfo.Rate.LoyaltyHotelTaxFeeTotal = 15.7;
            planningData.DestinationInfo.RoomCode = "QUA.DB";
            planningData.ManualBooking.ConfirmationNumber = "235-7130377";
            planningData.DestinationInfo.RoomName = "QUADRUPLE WITH DOUBLE BED";
            planningData.DestinationInfo.Rate.RoomRateTotal = 120.73;
            planningData.DestinationInfo.Rate.HotelTaxFeeTotal = 15.7;
            planningData.DestinationInfo.RoomCorporateDisc = "ADN";
            planningData.ManualBooking.Comments = "Nice booking!";
            planningData.DestinationInfo.Rate.CancellationPolicies = [
            {'Amount': '100', LoyaltyAmount: '50', 'From': '2022-05-08T23:59:00-06:00', 'FromUTC': '', 'OffsetUTC': ''},
            {'Amount': '300', LoyaltyAmount: '200', 'From': '2022-05-13T23:59:00-06:00', 'FromUTC': '', 'OffsetUTC': ''},
            {'Amount': '200', LoyaltyAmount: '100', 'From': '2022-05-11T23:59:00-06:00', 'FromUTC': '', 'OffsetUTC': ''},
            ];
            */

            var isConfirmationNumberValid = planningData.ManualBooking.ConfirmationNumber != null && planningData.ManualBooking.ConfirmationNumber !== '';
            var isRoomName = planningData.DestinationInfo.RoomName != null && planningData.DestinationInfo.RoomName !== '';
            var isRoomCorporateDisc = planningData.DestinationInfo.RoomCorporateDisc != null && planningData.DestinationInfo.RoomCorporateDisc !== '';

            var isRoomRateTotal = planningData.DestinationInfo.Rate.RoomRateTotal != null &&
                planningData.DestinationInfo.Rate.RoomRateTotal !== '' &&
                planningData.DestinationInfo.Rate.RoomRateTotal >= 0;

            var isHotelTaxFeeTotal = planningData.DestinationInfo.Rate.HotelTaxFeeTotal != null &&
                planningData.DestinationInfo.Rate.HotelTaxFeeTotal !== '' &&
                planningData.DestinationInfo.Rate.HotelTaxFeeTotal >= 0;

            var isCancellationPolicy = planningData.ManualBooking.CancellationPolicy != null && planningData.ManualBooking.CancellationPolicy !== '';
            var isComments = planningData.ManualBooking.Comments != null && planningData.ManualBooking.Comments !== '';


            var isRoomTypeCode = planningData.DestinationInfo.RoomTypeCode != null && planningData.DestinationInfo.RoomTypeCode !== '';
            var isRoomPlanCode = planningData.DestinationInfo.Rate.RatePlanCode != null && planningData.DestinationInfo.Rate.RatePlanCode !== '';

            var isHotelFeeTotal = planningData.DestinationInfo.Rate.HotelFeeTotal != null &&
                planningData.DestinationInfo.Rate.HotelFeeTotal !== '' &&
                planningData.DestinationInfo.Rate.HotelFeeTotal >= 0;

            var isRecoveryFee = planningData.DestinationInfo.Rate.RecoveryFee != null &&
                planningData.DestinationInfo.Rate.RecoveryFee !== '' &&
                planningData.DestinationInfo.Rate.RecoveryFee >= 0;

            // Only check excluded tax if its present
            var isExcludedTax = true;
            if (planningData.DestinationInfo.Rate.HotelExcludedTax != null &&
                planningData.DestinationInfo.Rate.HotelExcludedTax !== '' &&
                planningData.DestinationInfo.Rate.HotelExcludedTax < 0) {
                isExcludedTax = false;
            }

            // Hotelbeds fields
            var isPurchaseRoomRate = planningData.DestinationInfo.Rate.LoyaltyRoomRateTotal != null &&
                planningData.DestinationInfo.Rate.LoyaltyRoomRateTotal !== '' &&
                planningData.DestinationInfo.Rate.LoyaltyRoomRateTotal >= 0;

            var isPurchaseTotalTax = planningData.DestinationInfo.Rate.LoyaltyHotelTaxFeeTotal != null &&
                planningData.DestinationInfo.Rate.LoyaltyHotelTaxFeeTotal !== '' &&
                planningData.DestinationInfo.Rate.LoyaltyHotelTaxFeeTotal >= 0;

            var isRoomCode = planningData.DestinationInfo.RoomCode != null && planningData.DestinationInfo.RoomCode !== '';
            var hbCancellationPolicy = planningData.DestinationInfo.Rate.CancellationPolicies;

            var isValid = true;

            if (planningData.Provider === models.provider.Hotelbeds) {
                if (!isPurchaseRoomRate) {
                    isValid = false;
                }
                if (!isPurchaseTotalTax) {
                    isValid = false;
                }
                if (!isRoomCode) {
                    isValid = false;
                }
                if (!isExcludedTax) {
                    isValid = false;
                }

                var ISO_8601 = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d[+-]\d\d:\d\d?$/i;

                for (var i = 0; i < hbCancellationPolicy.length; i++) {
                    if (hbCancellationPolicy[i].From === '' || !ISO_8601.test(hbCancellationPolicy[i].From)) {
                        isValid = false;
                        break;
                    }
                    if (hbCancellationPolicy[i].Amount === '' ||
                        (isNaN(parseFloat(hbCancellationPolicy[i].Amount)) || (parseFloat(hbCancellationPolicy[i].Amount) < 0))) {
                        isValid = false;
                        break;
                    }
                    if (hbCancellationPolicy[i].LoyaltyAmount === '' ||
                        (isNaN(parseFloat(hbCancellationPolicy[i].LoyaltyAmount)) || (parseFloat(hbCancellationPolicy[i].LoyaltyAmount) < 0))) {
                        isValid = false;
                        break;
                    }
                }
            } else if (planningData.Provider === models.provider.Adestinn) {

                if (!isRoomTypeCode) {
                    isValid = false;
                }
                if (!isRoomPlanCode) {
                    isValid = false;
                }
                if (!isHotelFeeTotal) {
                    isValid = false;
                }
                if (!isRecoveryFee) {
                    isValid = false;
                }
                if (!isCancellationPolicy) {
                    isValid = false;
                }
            }

            if (!isConfirmationNumberValid) {
                isValid = false;
            }
            if (!isRoomName) {
                isValid = false;
            }
            if (!isRoomCorporateDisc) {
                isValid = false;
            }
            if (!isRoomRateTotal) {
                isValid = false;
            }
            if (!isHotelTaxFeeTotal) {
                isValid = false;
            }
            if (!isComments) {
                isValid = false;
            }
            this.ractive.set('isManualFormValid', isValid);
            return isValid;
        },

        removeCharacters: function () {
            $('#manualBookingForm .input-string').each(function () {
                var input = $(this);
                // remove random assortment of characters that shouldn't be present
                var text = input.val().replace(/[\#+~*<>{}]/g, '');
                // remove unicode
                text = text.replace(/[\u{0080}-\u{FFFF}]/gu, '');
                input.val(text);
            });
        },

        getBookUrl: function (planningData, isManualBooking) {
            if (isManualBooking &&
                planningData.DestinationInfo.Rate.CancellationPolicies) {
                // Save cancellation policies for next page
                this.state.cancellationPolicies = planningData.DestinationInfo.Rate.CancellationPolicies;
                this.state.loyaltyCancellationPolicies = planningData.DestinationInfo.Rate.CheckRateCancellationPolicies;
            } else if (isManualBooking && !planningData.DestinationInfo.Rate.CancellationPolicies) {
                this.state.cancellationPolicies = null;
            }
            var qs = bookingService.serializePlanning(planningData);
            return '/#/book/{0}'.format(qs);
        },



        validateCheckAvailability: function (planningData) {
            var errors = [];
            var from = moment(planningData.Timeline.FromDate);
            var to = moment(planningData.Timeline.ToDate);
            var today = moment();
            today.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });

            if (!from.isValid() || !to.isValid()) {
                errors.push('Please select a valid date range.');
            } else if (from > to) {
                errors.push('(From:) date must be before (To:) date');
            } else if (from < today || to < today) {
                errors.push('(From:) and (To:) must be in the future.');
            } else if (to.diff(from, 'day') > 14) {
                errors.push('(From:) date and (To:) date must be within 14 days.');
            }

            if (planningData.TravelerInfo.AdultCount <= 0 || planningData.TravelerInfo.AdultCount > 10) {
                errors.push('Invalid number of adults selected');
            }
            if (planningData.TravelerInfo.ChildCount < 0 || planningData.TravelerInfo.ChildCount > 10) {
                errors.push('Invalid number of children selected');
            }

            for (var i = 0; i < planningData.TravelerInfo.ChildAges.length; i++) {
                if (planningData.TravelerInfo.ChildAges[i] > 17 || planningData.TravelerInfo.ChildAges[i] < 0) {
                    errors.push('Invalid child age selected. Ages must be between 0 and 17');
                    break;
                }
            }

            this.ractive.set('messenger.Errors', errors);
            console.log(errors);
            return errors.length === 0;
        },

        validatePhoneNumber: function () {
            var errors = [];
            var phoneNumber = window.Utilities.cleansePhone($('#userPhoneNumber').val());
            if (phoneNumber.length <= 7 || phoneNumber.length >= 14) {
                errors.push('Invalid phone number');
            }
            this.ractive.set('messenger.Errors', errors);
            return errors.length === 0;
        },

        clearRooms: function () {
            this.ractive.set('availability.Rooms', null);
            this.ractive.set('messenger', null);
            this.state.changes = true;
            this.state.rooms = null;
        },

        clearPreviousResults: function () {
            if (window.app.controllerManager.state.hotelnewsearch &&
                window.app.controllerManager.state.hotelnewsearch.searchResults) {
                window.app.controllerManager.state.hotelnewsearch.searchResults = null;
            }
        },

        compareStateAndPlanning: function () {
            var initPlanningData = this.initPlanningData;
            var statePlanning = this.prevPlanningData;
            if (statePlanning) {
                console.log('init: ', this.initPlanningData);
                console.log('state: ', statePlanning);
                if (statePlanning.TravelerInfo.AdultCount === initPlanningData.TravelerInfo.AdultCount &&
                    statePlanning.TravelerInfo.ChildCount === initPlanningData.TravelerInfo.ChildCount &&
                    statePlanning.Timeline.FromDate === initPlanningData.Timeline.FromDate &&
                    statePlanning.Timeline.ToDate === initPlanningData.Timeline.ToDate) {
                    for (var i = 0; i < statePlanning.TravelerInfo.ChildAges; i++) {
                        if (statePlanning.TravelerInfo.ChildAges[i] !== initPlanningData.TravelerInfo.ChildAges[i]) {
                            return false;
                        }
                    }
                    console.log('true');
                    return true;
                }
            }
            return false;
        },

        /**
         * simply update the member's phone.
         */
        onPhoneChange: function (e) {
            if (this.validatePhoneNumber()) {
                $.postJSON('/api/users/updatephone/?phone=' + this.ractive.get('data.user.Phone'))
                    .then(null, function (err) {
                        return this.ractive.set('messenger.Errors', window.Utilities.getFriendlyErrors(err));
                    }.bind(this));
            }
        },



        /**
         * Go grab nightly info for this room, given the current session data
         * @param {Ractive Event} e 
         */
        onGetRateDetails: function (e, index) {
            //clear night/error info
            this.ractive.set('RateDetails.Nights', null);
            this.ractive.set('RateDetailsErrors.Errors', null);

            e.original.preventDefault();
            var r = e.context;

            if (r.planningData.Provider === models.provider.Adestinn) {
                r.loadingRateDetails = true;
                this.ractive.set(e.keypath, r);
                var roomData = r.planningData;
                $.postJSON('/api/booking/getratedetails/', roomData).then(function (nights) {
                    r.loadingRateDetails = false;
                    this.ractive.set(e.keypath, r);

                    this.ractive.set('RateDetails.Nights', nights);

                    $.fancybox({
                        'href': '#nightly-rate-modal'
                    });
                }.bind(this), function (err) {
                    r.loadingRateDetails = false;
                    this.ractive.set(e.keypath, r);

                    //used for testing: this.ractive.set('RateDetails.Nights', [{ Rate: 12.34, ReservationDate: new Date() }, { Rate: 123.34, ReservationDate: new Date() }, { Rate: 1342.34, ReservationDate: new Date() }] );
                    var serverMsg = utils.tryGetValue(err, 'responseJSON.Message');
                    var message = serverMsg != null ? '<br/><br/>{0}<br/><br/>'.format(serverMsg) : '';
                    this.ractive.set('RateDetailsErrors.Errors', ['There was a problem retrieving rate details.{0}Please try again later.'.format(message)]);

                    $.fancybox({
                        'href': '#nightly-rate-modal'
                    });
                }.bind(this));
            } else {
                this.ractive.set('RateDetails.Nights', r.Nights);
                $.fancybox({
                    'href': '#nightly-rate-modal'
                });
            }
        },

        unload: function () {
            if (this.ractive != null) {
                this.ractive.teardown();
                console.log('teardown');
            }
            if (this.lazyload != null) {
                this.lazyload.destroy();
            }
            if (this.lazyDom != null) {
                this.lazyDom.destroy();
            }
            this.map = null;
            this.dialog = null;
            this.state = null;
            this.lazyload = null;
            this.lazyDom = null;
            this.ractive = null;
            this.$window = null;
        },
    };
});

